module.exports = "/wp-content/themes/noon/public/dist/svgs/chevron-right.svg";